import { useNavigate } from 'react-router-dom';
import type { ListeningHistoryEntry } from '@/mocks/listenerCenter';

interface Props {
  history: ListeningHistoryEntry[];
}

export default function ListeningHistory({ history }: Props) {
  const navigate = useNavigate();
  const slug = (name: string) => name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const formatTime = (iso: string) => {
    const d = new Date(iso);
    const now = new Date();
    const diffMs = now.getTime() - d.getTime();
    const diffHrs = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffHrs < 1) return 'Hace unos minutos';
    if (diffHrs < 24) return `Hace ${diffHrs}h`;
    if (diffDays === 1) return 'Ayer';
    if (diffDays < 7) return `Hace ${diffDays} días`;
    return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'short' });
  };

  const formatMinutes = (min: number) => {
    if (min >= 60) {
      const h = Math.floor(min / 60);
      const m = min % 60;
      return m > 0 ? `${h}h ${m}min` : `${h}h`;
    }
    return `${min} min`;
  };

  const totalHours = Math.round(history.reduce((acc, e) => acc + e.durationMinutes, 0) / 60);

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-foreground-950">Historial de Escucha</h3>
        <span className="text-xs text-foreground-500">{totalHours}h esta semana</span>
      </div>
      <div className="bg-background-50 rounded-2xl divide-y divide-background-100 overflow-hidden">
        {history.map((entry) => (
          <div
            key={entry.id}
            className="flex items-center gap-3 px-5 py-3.5 hover:bg-background-100/50 transition-all cursor-pointer"
            onClick={() => navigate(`/radio/${slug(entry.stationName)}`)}
          >
            <img
              src={entry.logoUrl}
              alt={entry.stationName}
              className="w-10 h-10 rounded-xl object-cover object-top shrink-0"
            />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <h4 className="text-sm font-semibold text-foreground-950 truncate">{entry.stationName}</h4>
                <span className="text-[10px] text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded whitespace-nowrap">{entry.frequency}</span>
              </div>
              <p className="text-xs text-foreground-500 truncate mt-0.5">{entry.programName}</p>
            </div>
            <div className="text-right shrink-0">
              <div className="text-xs font-medium text-foreground-700">{formatMinutes(entry.durationMinutes)}</div>
              <div className="text-[10px] text-foreground-400">{formatTime(entry.listenedAt)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}